module.exports = __webpack_public_path__ + "media/src/images/icon/sns/tw-2a4787a3a8b52040dd105bb509c908b3.png";